import { store } from '@/store';
import { logger } from '@/utils/logger/logger';
import offlineAudioRecorder from '@/utils/offlineAudioRecorder';
import { isSafari } from 'react-device-detect';
let audioBlobs: BlobPart[] | undefined = [];
let mediaRecorder: MediaRecorder | null = null;
let stream: MediaStream | null = null;

// let start = 0;

// todo: make these mutations
export async function startOfflineRecordingAudio() {
  if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
    logger.debug(
      'mediaDevices API or getUserMedia method is not supported in this browser.'
    );
    return false;
  }

  if (mediaRecorder) {
    mediaRecorder?.stop();
    stream?.getTracks().forEach((track) => track?.stop());
    mediaRecorder = null;
    stream = null;
  }

  stream = await navigator.mediaDevices.getUserMedia({
    video: false,
    audio: isSafari
      ? {
          deviceId: store.getState().audio.selectedAudioSource?.deviceId,
        }
      : {
          autoGainControl: false,
          echoCancellation: false,
          noiseSuppression: false,
          deviceId: store.getState().audio.selectedAudioSource?.deviceId,
        },
  });
  audioBlobs = [];

  mediaRecorder = new MediaRecorder(stream);

  mediaRecorder.addEventListener('dataavailable', (event) => {
    if (audioBlobs) {
      audioBlobs.push(event.data);
    }
  });

  // start = Date.now();
  mediaRecorder.start();

  return true;
}

export interface RecordingResult {
  blob: Blob;
  duration: number;
  mimeType: string;
}

export function stopOfflineRecordingAudio(): Promise<RecordingResult> {
  const { offlineRecordingStartTime } = store.getState().scribeRecordModel;
  return new Promise<RecordingResult>((resolve) => {
    offlineAudioRecorder?.setOnStopHandler((blob) => {
      const duration = (Date.now() - offlineRecordingStartTime) / 1000;
      const mimeType = blob.type;
      logger.debug('stopping offline recording class - mime type: ' + mimeType);
      resolve({ blob, duration, mimeType });
    });

    offlineAudioRecorder?.stop();
  });
}
